import { request } from '../../helpers/api/request';

export const logout = async () => {
    const { data } = await request({
        url: 'auth/logout',
    });

    return data;
};
